import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Screenshot = makeShortcode("Screenshot");
const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`You can manage settings for your user account profile from the web or command line.`}</p>
    <h2>{`Managing user account profile settings from the web`}</h2>
    <p>{`From the web, you can change the following user profile settings:`}</p>
    <ul>
      <li parentName="ul">{`Avatar`}</li>
      <li parentName="ul">{`Password`}</li>
      <li parentName="ul">{`Full name`}</li>
      <li parentName="ul">{`Link GitHub Account`}</li>
      <li parentName="ul">{`Link Twitter Account`}</li>
      <li parentName="ul">{`Email address added to package metadata`}</li>
      <li parentName="ul">{`Two-factor authentication status`}</li>
    </ul>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['account-settings'].text}</>
        <>{shared['account-settings'].image}</>
      </li>
    </ol>
    <h3>{`Linking your npm and GitHub accounts`}</h3>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`On the account settings page, you will find a button to link your GitHub account. Click that.`}</p>
        <Screenshot src="/getting-started/managing-your-npm-user-account/connect-github.png" alt="Screenshot of linking from Account Setting without any accounts linked" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`If you are not currently logged in to GitHub you will be prompted to go through the authentication flow.`}</p>
        <Screenshot src="/getting-started/managing-your-npm-user-account/github-login.png" alt="GitHub login form" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`After successfully logging in, or if you already had an active browser sessions, you will be prompted to "authorize npm account link", click the button.`}</p>
        <Screenshot src="/getting-started/managing-your-npm-user-account/github-authorize.png" alt="Landing page to authorize the installation of the npm account linking app" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will be redirected to npm and the link will show as successful in your settings.`}</p>
        <Screenshot src="/getting-started/managing-your-npm-user-account/github-success.png" alt="Screenshot of linking from Account Setting with successfully linked GitHub account" mdxType="Screenshot" />
      </li>
    </ol>
    <h3>{`Linking your npm and Twitter accounts`}</h3>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`On the account settings page, you will find a button to link your Twitter account. Click that.`}</p>
        <Screenshot src="/getting-started/managing-your-npm-user-account/connect-twitter.png" alt="Screenshot of linking from Account Setting without any accounts linked" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`If you are not currently logged in to Twitter you will be prompted to go through the authentication flow. Click "Log in"`}</p>
        <Screenshot src="/getting-started/managing-your-npm-user-account/twitter-login.png" alt="Twitter login form" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`After successfully logging in, or if you already had an active browser sessions, you will be prompted to "Authorize app", click the button.`}</p>
        <Screenshot src="/getting-started/managing-your-npm-user-account/twitter-authorize.png" alt="Landing page to authorize the installation of the npm account linking app" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will be redirected to npm and the link will show as successful in your settings.`}</p>
        <Screenshot src="/getting-started/managing-your-npm-user-account/twitter-success.png" alt="Screenshot of linking from Account Setting with successfully linked Twitter account" mdxType="Screenshot" />
      </li>
    </ol>
    <h3>{`Disconnecting your GitHub account from npm`}</h3>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`On the account settings page, you will find a button to disconnect your GitHub account. Click that.`}</p>
        <Screenshot src="/getting-started/managing-your-npm-user-account/github-disconnect.png" alt="Screenshot of linking from Account Setting with a cursor hovering over disconnect" mdxType="Screenshot" />
        <p parentName="li"><em parentName="p">{`Note: Clicking disconnect will only disconnect the link from your npm account. You need to `}<inlineCode parentName="em">{`revoke`}</inlineCode>{` permissions from your `}<a parentName="em" {...{
              "href": "https://github.com/settings/apps/authorizations"
            }}>{`GitHub app authorization settings`}</a>{` to permanently remove the integration from your GitHub account`}</em></p>
      </li>
    </ol>
    <h3>{`Disconnecting your Twitter account from npm`}</h3>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`On the account settings page, you will find a button to disconnect your GitHub account. Click that.`}</p>
        <Screenshot src="/getting-started/managing-your-npm-user-account/twitter-disconnect.png" alt="Screenshot of linking from Account Setting with a cursor hovering over disconnect" mdxType="Screenshot" />
        <p parentName="li"><em parentName="p">{`Note: Clicking disconnect will only disconnect the link from your npm account. You need to `}<inlineCode parentName="em">{`revoke`}</inlineCode>{` permissions from your `}<a parentName="em" {...{
              "href": "https://twitter.com/settings/connected_apps"
            }}>{`Twitter connect apps management page`}</a>{` to permanently remove the integration from your Twitter account`}</em></p>
      </li>
    </ol>
    <h2>{`Managing user account profile settings from the command line`}</h2>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` Your npm client must be version 5.5.1 or higher to change your account settings from the CLI. To update to the latest version of npm, on the command line, run `}<inlineCode parentName="p">{`npm install npm@latest -g`}</inlineCode></p>
    </Note>
    <h3>{`Viewing user account profile settings from the command line`}</h3>
    <p>{`To view your user profile settings from the CLI, on the command line, run the following command:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm profile get
`}</code></pre>
    <Screenshot src="/getting-started/managing-your-npm-user-account/profile-settings-cli.png" alt="Screenshot of command-line interface profile settings table" mdxType="Screenshot" />
    <h3>{`Updating user account profile settings from the command line`}</h3>
    <p>{`From the CLI, you can change the following properties for your user account:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`email`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`two-factor auth`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`fullname`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`homepage`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`freenode`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`password`}</inlineCode></li>
    </ul>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`On the command line, type the following command, replacing `}<inlineCode parentName="p">{`property`}</inlineCode>{` with the name of the property, and `}<inlineCode parentName="p">{`value`}</inlineCode>{` with the new value:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm profile set <prop> <value>
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`When prompted, provide your current password.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`If you have enabled two-factor authentication on your account, when prompted, enter a one-time password.`}</p>
      </li>
    </ol>
    <p>{`For more details, see the `}<inlineCode parentName="p">{`profile`}</inlineCode>{` `}<a parentName="p" {...{
        "href": "https://docs.npmjs.com/cli/profile"
      }}>{`command line documentation`}</a>{`.`}</p>
    <h4>{`Setting a password from the command line`}</h4>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`On the command line, type the following command:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm profile set password
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`When prompted, provide your current password.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`When prompted, type a new password.`}</p>
      </li>
    </ol>
    <Note mdxType="Note">
      <p>{`To protect your account, when you reset your password from the command line, it must:`}</p>
      <ul>
        <li parentName="ul">{`be longer than 10 characters`}</li>
        <li parentName="ul">{`not contain part of your username`}</li>
        <li parentName="ul">{`not be on `}<a parentName="li" {...{
            "href": "https://www.npmjs.com/signup/common-passwords"
          }}>{`this list of common passwords`}</a></li>
        <li parentName="ul">{`not be in the "`}<a parentName="li" {...{
            "href": "https://haveibeenpwned.com/"
          }}>{`Have I Been Pwned`}</a>{`" breach database`}</li>
      </ul>
    </Note>
    <h4>{`Configuring two-factor authentication from the command line`}</h4>
    <p>{`Enabling two-factor authentication on your account helps protect against unauthorized access to your account and packages.`}</p>
    <p>{`To enable, configure, and disable two-factor authentication from the command line, see "`}<a parentName="p" {...{
        "href": "/configuring-two-factor-authentication#configuring-2fa-from-the-command-line"
      }}>{`Configuring two-factor authentication`}</a>{`".`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      